import { useUnit } from 'effector-react'
import * as React from 'react'

import { $gift, giftMounted, getGift, giftCategoriesList } from './model'
import { $giftsCategories } from '../../giftsCategories/list/model'

export const useGift = () => {
  const gift = useUnit($gift)
  const giftCategories = useUnit($giftsCategories).map((category) => ({
    id: category.id,
    name: category.name,
  }))
  const loading = useUnit(getGift.pending)

  React.useEffect(() => {
    giftMounted()
    giftCategoriesList()
  }, [])

  return { gift, loading, giftCategories }
}
